import React, { FC } from "react";
import FormFromJson from "../../../common/FormFromJson/FormFromJson";
import { HeaderVariant } from "../../../common/Header/Header";
import PageContainer, { PageContainerVariant } from "../../../common/PageContainer/PageContainer";
import WizardLeftPanel from "../../Wizard/tools/WizardLeftPanel/WizardLeftPanel";

const ProfileSetupReviewStep: FC = () => {
   return (
      <PageContainer
         variant={PageContainerVariant.Variant3}
         headerConfig={{ variant: HeaderVariant.RegisteredUser }}
      >
         <FormFromJson
            jsonUrl={"profile-setup/step-page/review"}
            disableSubmitButtonWhenFormIsIncomplete={false}
            renderLeftColumn={formJson => <WizardLeftPanel leftPanelJson={formJson.leftPanel} />}
         />
      </PageContainer>
   );
};

export default ProfileSetupReviewStep;
